<template>
	<div class="detain-body open-detain">
		<div class="detain-main">
			<!-- backgrund -->
			<img
				class="detain-main-background"
				src="../../mycomponents/img/dialog/detainbackrgound.png"
				alt=""
			/>
			<!-- close -->
			<img
				class="detain-main-close"
				@click="closeDetain"
				src="../../mycomponents/img/dialog/detainclose.png"
				alt=""
			/>
			<!-- 倒计时 -->
			<div class="detain-main-timedown">
				<span>{{ $t("onlyleftuntilendtheactivity") }}</span>
				<span class="detain-main-timedown-black">{{ reshour ? reshour : "00" }}</span>
				<span class="detain-main-timedown-black">{{ resminute ? "0" + resminute : "00" }}</span>
				<span class="detain-main-timedown-black">{{ ressecond ? ressecond : "00" }}</span>
			</div>
			<!-- 支付二维码 -->
			<div class="detain-main-pay">
				<div class="detain-main-pay-erweima">
					<img
						:src="payQrcode"
						alt=""
						@load="
							() => {
								isImgReady = true;
							}
						"
					/>
					<div
						:class="isImgReady ? 'detain-main-pay-erweima-default' : 'detain-main-pay-erweima-load'"
					></div>
				</div>
				<div class="detain-main-pay-logo">
					<img src="../../mycomponents/img/shop/sty weixin.svg" alt="" />
					<img src="../../mycomponents/img/shop/syt zfb.svg" alt="" />
					<span>{{ $t("codescanningpayment") }}</span>
				</div>
			</div>
			<p class="detain-main-zfbpay" @click="zfbPay">{{ $t("text013") }}</p>
		</div>
	</div>
</template>

<script>
import config from "../../plugins/config";
import {paymerge, payorderstatedetails, payorder} from "../../plugins/sdk";
export default {
	data() {
		return {
			taocanObj: config.PAY_Less_PACKAGES,
			payQrcode: "",
			timerPayState: "",
			endTime: "",
			resTime: 5 * 60 * 1000,
			timeinterval: "",
			isImgReady: false,
		};
	},
	computed: {
		userData() {
			return this.$local.userLoginData;
		},
		reshour() {
			return parseInt(this.resTime / 1000 / 60 / 60);
		},
		resminute() {
			return parseInt((this.resTime % (1000 * 60 * 60)) / 1000 / 60);
		},
		ressecond() {
			return parseInt((this.resTime % (1000 * 60)) / 1000) >= 10
				? parseInt((this.resTime % (1000 * 60)) / 1000)
				: "0" + parseInt((this.resTime % (1000 * 60)) / 1000);
		},
	},
	methods: {
		// 检测是否到下一天

		// 获取结束时间
		getEndTime() {
			let time1 = new Date();
			let time2 = new Date();
			time2.setTime(time1.getTime() + 5 * 60 * 1000 + 1000);
			// time2.setHours(0, 0, 0, 0);
			this.endTime = time2.getTime();
		},
		// 获取当前时间并返回剩余时间
		getRestTime() {
			let time = new Date();
			this.resTime = this.endTime - time.getTime();
			if (this.resTime <= 0) this.closeDetain();
		},
		// 点击右上角关闭关闭shop
		async closeDetain() {
			clearInterval(this.timerPayState);
			await this.$app.getUserInfo();
			config.PAY_Less_PACKAGES[0].res = "";
			this.$emit("close");
		},
		// 请求接口部分
		// 获取当前选择订单的支付二维码
		payCreate() {
			let item = this.taocanObj[0];
			// console.log("item", item);
			// console.log("我选中的套餐", item);
			if (item.res) {
				this.payCreateFun(item.res);
				return;
			}
			paymerge({
				account: this.userData.username,
				productinfo: item.paypack,
				width: 85,
				iflogo: 0,
			}).then((res) => {
				console.log("请求二维码返回的数据", res);
				if (res.code == 10000) {
					item.res = res;
					this.payCreateFun(res);
				}
			});
		},
		payCreateFun(res) {
			this.payQrcode = res.qrcode;
			clearInterval(this.timerPayState);
			this.timerPayState = setInterval(() => {
				this.payState(res.orderno);
			}, 3000);
		},
		//更新支付状态
		payState(orderno) {
			payorderstatedetails({
				account: this.userData.username,
				orderno,
			})
				.then((res) => {
					console.log("该订单是否支付", res);
					if (res) {
						clearInterval(this.timerPayState);
						// registerOCPC(this.$local.userLoginData);
						return this.$app.getUserInfo().then(() => {
							//支付埋点
							if (this.$app.VIPlevel === 2) {
								window.gevt("SKU_78", "支付事件", "None", "None", "None", "None");
							}
							//支付成功关闭shop模态框并回调
							this.closeDetain();
						});
					} else {
						this.$toast.error(this.$t("paymentfail"));
					}
				})
				.catch((err) => {
					console.log("未支付", err);
				});
		},
		// 点击打开支付宝订单监听
		zfbPay() {
			clearInterval(this.timerPayState);
			let item = this.taocanObj[0];
			// if (item.zfbsrc) {
			// 	return;
			// }
			let data = {
				orderpackinfo: item.zfbpaypack,
				account: this.$local.userLoginData.username,
				paymethod: "alipay",
			};
			payorder(data).then((res) => {
				console.log("支付宝地址获取", res);
				var a = document.createElement("a");
				a.href = res.paygateway;
				a.target = "_blank";
				a.click();
				a.remove();
				let _this = this;
				this.timerPayState = setInterval(() => {
					_this.payState(res.orderno);
				}, 3000);
			});
		},
	},
	mounted() {
		window.gevt("页面浏览", "视图事件", "挽留弹窗", "None", "None", "None");
		this.payCreate();
		this.getEndTime();
		this.timeinterval = setInterval(() => {
			this.getRestTime();
		}, 1000);
	},
	beforeDestroy() {
		clearInterval(this.timeinterval);
	},
};
</script>

<style lang="less">
/* body */
.detain-body {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.4);
	z-index: 9999;
	display: none;
	justify-content: center;
	align-items: center;
}

/* main */
.detain-main {
	height: 431rem;
	width: 394rem;
	position: relative;
	display: flex;
	// justify-content: center;
	flex-direction: column;
	align-items: center;
	.detain-main-background {
		width: 100%;
		height: 100%;
		display: block;
		position: absolute;
		left: 0;
		top: 0;
	}
	.detain-main-close {
		width: 32rem;
		height: 32rem;
		display: block;
		position: absolute;
		right: 10rem;
		top: -16rem;
		cursor: pointer;
	}
	.detain-main-timedown {
		margin-top: 80rem;
		z-index: 10000;
		display: flex;
		height: 21rem;
		// justify-content: center;
		align-items: center;
		.detain-main-timedown-black {
			width: 21rem;
			height: 21rem;
			background: #282a43;
			opacity: 1;
			border-radius: 3rem;
			color: #ffffff;
			opacity: 1;
			line-height: 21rem;
			text-align: center;
		}
		span {
			font-size: 12rem;
			font-family: PingFang SC;
			color: #5c7099;
			&:nth-of-type(1) {
				font-size: 13rem;
			}
			&:nth-of-type(2) {
			}
			&:nth-of-type(3),
			&:nth-of-type(4) {
				margin-left: 8rem;
				position: relative;
				&::before {
					content: ":";
					position: absolute;
					color: #5c7099;
					left: -5rem;
				}
			}
		}
	}
	.detain-main-pay {
		display: flex;
		// justify-content: center;
		flex-direction: column;
		align-items: center;
		z-index: 10000;
		width: 98rem;
		height: 117rem;
		margin-top: 175rem;
		margin-right: 125rem;
		// overflow: hidden;
		.detain-main-pay-erweima {
			width: 85rem;
			height: 85rem;
			position: relative;
			margin-bottom: 5rem;
			img {
				height: 100%;
				width: 100%;
				display: block;
			}
			.detain-main-pay-erweima-default {
				position: absolute;
				width: 85rem;
				height: 85rem;
				top: 0;
				left: 0;
				transition: opacity 0.5s;
				opacity: 0;
			}
			.detain-main-pay-erweima-load {
				position: absolute;
				width: 85rem;
				height: 85rem;
				top: 0;
				left: 0;
				box-sizing: border-box;
				opacity: 1;
				transition: opacity 0.5s;
				box-sizing: border-box;
				background-repeat: no-repeat;
				background-size: 60rem, 60rem;
				background-position: center center;
				background-image: url("../../mycomponents/img/login/微信二维码等待.gif");
			}
		}
		.detain-main-pay-logo {
			display: flex;
			justify-content: center;
			img {
				width: 15.17rem;
				height: 14.94rem;
				&:nth-of-type(2) {
					margin-right: 10rem;
					margin-left: 4rem;
				}
			}
			span {
				font-size: 9rem;
				font-family: MicrosoftYaHei;
				color: #333333;
				opacity: 1;
			}
		}
	}
	.detain-main-zfbpay {
		position: absolute;
		bottom: 81rem;
		right: 85rem;
		z-index: 1001;
		width: 110rem;
		height: 14rem;
		font-size: 10rem;
		font-family: MicrosoftYaHei;
		// line-height: 23rem;
		color: #5c7099;
		opacity: 1;
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
}

/* js */
.open-detain {
	display: flex !important;
}
</style>
